<template>
  <div class="px-ogs relative">
    
    <div class="swiper-button-container">
      <button
        class="swiper-button"
        :class="theme === 'dark' ? 'swiper-button--white' : ''"
        @click="prev"
      >
        <div class="swiper-button__inner">&larr;</div>
      </button>
    </div>

    <swiper :options="swiperOptions" ref="swiper">
    <SwiperSlide v-for="product in products" :key="product.id">
      <slot :name="'product-' + product.id">
      </slot>
    </SwiperSlide>
  </swiper>

    <div class="swiper-button-container">
      <button
        class="swiper-button"
        :class="theme === 'dark' ? 'swiper-button--white' : ''"
        @click="next"
      >
        <div class="swiper-button__inner">&rarr;</div>
      </button>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  title: 'Default',
  props: {
    theme: String,
    products: Array
  },
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      swiperOptions: {
        loop: true,
        speed: 750,
        slidesPerView: 1,
        spaceBetween: 48,
        breakpoints: {
          768:{
            slidesPerView: 2
          },
           1024: {
              slidesPerView: 3,
              spaceBetween: 48
            }
          }
      },
    };
  },
  methods: {
  prev() {
    if (this.$refs.swiper && this.$refs.swiper.$swiper) {
      this.$refs.swiper.$swiper.slidePrev();
    }
  },
  next() {
    if (this.$refs.swiper && this.$refs.swiper.$swiper) {
      this.$refs.swiper.$swiper.slideNext();
    }
  },
},



  
};
</script>

<style>

.swiper-wrapper {
  height: auto !important;
}

.swiper-slide {
  height: 100%;
  overflow: hidden;
}

.swiper-button-container {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10; 

}

.swiper-button-container:first-of-type {
  left: 30px;
  @media (max-width: 1024px) {
    left: 5px;
  }
}

.swiper-button-container:last-of-type {
  right: 30px;
  @media (max-width: 1024px) {
    right: 5px;
  }
}



</style>